export function _p(className: string) {
  return `.${className}`;
}

export function _self(className: string) {
  return `&.${className}`;
}
